// Patch Event.prototype.preventDefault to prevent Chromium's touchmove cancelable=false intervention warnings.
(function() {
    const originalPreventDefault = Event.prototype.preventDefault;
    Event.prototype.preventDefault = function() {
        if (this.cancelable) {
            originalPreventDefault.call(this);
        }
    };
})();

document.addEventListener('DOMContentLoaded', function() {
    // Exclude desktop screens: only run if viewport width is less than 768px
    if (window.innerWidth >= 768) {
        return;
    }

    const mainContent = document.getElementById('MainContent');
    if (!mainContent || mainContent.getAttribute('data-fullpage-enabled') !== 'true') {
        return;
    }

    const shopifySections = mainContent.querySelectorAll('.shopify-section');
    const footer = document.querySelector('footer');

    let fpContainer = mainContent;
    let sectionSelector = '.shopify-section, footer';
    let tooltips = [];

    // If there is only one shopify section on the page, it's a mega-section (e.g. index, help page)
    // containing multiple nested <section> tags. We initialize fullPage.js on that section instead of #MainContent.
    if (shopifySections.length === 1) {
        fpContainer = shopifySections[0];
        
        // Move footer inside the mega-section wrapper so it acts as the last slide
        if (footer) {
            footer.classList.add('fp-auto-height');
            fpContainer.appendChild(footer);
        }

        // Get inner sections as slides
        const innerSlides = fpContainer.querySelectorAll('section, footer');
        innerSlides.forEach((slide, index) => {
            if (slide.tagName.toLowerCase() === 'footer') {
                tooltips.push('Pie de página');
            } else {
                const titleAttr = slide.getAttribute('id') || slide.className;
                tooltips.push(titleAttr ? titleAttr.split(' ')[0] : `Sección ${index + 1}`);
            }
        });
        sectionSelector = 'section, footer';

    } else {
        // Multiple independent shopify sections
        if (footer) {
            footer.classList.add('fp-auto-height');
            mainContent.appendChild(footer);
        }

        const sections = mainContent.querySelectorAll('.shopify-section, footer');
        sections.forEach((section, index) => {
            if (section.tagName.toLowerCase() === 'footer') {
                tooltips.push('Pie de página');
            } else {
                const innerSection = section.querySelector('[data-section-title]');
                const title = innerSection ? innerSection.getAttribute('data-section-title') : `Sección ${index + 1}`;
                tooltips.push(title);
            }
        });
        sectionSelector = '.shopify-section, footer';
    }

    // Initialize fullPage.js
    if (typeof fullpage !== 'undefined') {
        new fullpage(fpContainer, {
            // Selectors
            sectionSelector: sectionSelector,
            
            // Navigation dots on the right side
            navigation: true,
            navigationPosition: 'right',
            navigationTooltips: tooltips,
            showActiveTooltip: false,
            
            // Scrolling physics and settings
            css3: true,
            scrollingSpeed: 700,
            autoScrolling: true,
            fitToSection: true,
            scrollBar: false,
            easing: 'easeInOutCubic',
            easingcss3: 'ease',
            
            // Essential for mobile content larger than viewport: allows internal scrolling
            scrollOverflow: true, 
            
            // Elements that shouldn't trigger fullpage scroll transitions when scrolled internally
            normalScrollElements: '#mm, .rs-menu, .drawer, .modal, .quick-add-modal, .search-modal, #nav',
            
            // Accessibility and behavior
            keyboardScrolling: true,
            animateAnchor: true,
            recordHistory: false,
            
            // Design
            controlArrows: true,
            verticalCentered: true,
            
            // Events
            onLeave: function(origin, destination, direction) {
                const nv = document.getElementById('nav');
                if (nv) {
                    if (destination.index > 0) {
                        nv.classList.add('sc');
                    } else {
                        nv.classList.remove('sc');
                    }
                }
            }
        });
    }
});
